import { create } from 'zustand';
import { ApiUtils, ProductApi, ProductWithCurrencies, RequestStrategyEnum } from '@shared/api';

interface IProductsWithCurrenciesStore {
  loading: boolean;
  error: string | null;
  products: ProductWithCurrencies[];
  getProducts: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useProductsWithCurrenciesStore = create<IProductsWithCurrenciesStore>((set) => ({
  loading: false,
  error: null,
  products: [],

  getProducts: ApiUtils.wrapperApi(async (signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await ProductApi.getProductsWithCurrencies(signal);
      set({ products: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ products: [], loading: false, error: null }),
}));
